import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

export const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const validateForm = (formData) => {
    const nameRegex = /^[A-Za-z ]{2,}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    // if (
    //   !nameRegex.test(formData.name) ||
    //   !nameRegex.test(formData.last_name)
    // ) {
    //   toast.error("Please enter valid first and last names");
    //   return false;
    // }

    if (!emailRegex.test(formData.user_email)) {
      toast.error("Invalid email address");
      return false;
    }

    if (!phoneRegex.test(formData.phone_no)) {
      toast.error("Phone number must be 10 digits");
      return false;
    }

    if (!formData.message || formData.message.trim().length < 5) {
      toast.error("Message must be at least 5 characters");
      return false;
    }

    return true;
  };

  const sendBrevoReply = async (formData) => {
    try {
      const response = await axios.post(
        "https://api.brevo.com/v3/smtp/email",
        {
          sender: {
            name: process.env.REACT_APP_BREVO_SENDER_NAME,
            email: process.env.REACT_APP_BREVO_SENDER_EMAIL,
          },
          to: [
            {
              email: formData.user_email,
              name: `${formData.name} ${formData.last_name}`,
            },
          ],
          templateId: Number(process.env.REACT_APP_BREVO_TEMPLATE_ID),
          params: {
            name: formData.name,
            message: formData.message,
          },
        },
        {
          headers: {
            "api-key": process.env.REACT_APP_BREVO_API_KEY,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Brevo reply sent", response.data);
    } catch (error) {
      console.error("Brevo auto-reply error:", error);
    }
  };
  

  const sendEmail = (e) => {
    e.preventDefault();
    const data = new FormData(form.current);

    const formData = {
      name: data.get("name"),
      last_name: data.get("last_name"),
      user_email: data.get("user_email"),
      phone_no: data.get("phone_no"),
      message: data.get("message"),
    };

    if (!validateForm(formData)) return;

    setLoading(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        toast.success("Message sent successfully!");
        form.current.reset();
        sendBrevoReply(formData);
      })
      .catch(() => {
        toast.error("Failed to send message. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <ToastContainer position="top-right" autoClose={4000} />
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                  src={contactImg}
                  alt="Contact Us"
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Get In Touch</h2>
                  <form ref={form} onSubmit={sendEmail}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input type="text" name="name" placeholder="First Name" required />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="text" name="last_name" placeholder="Last Name" required />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="email" name="user_email" placeholder="Email" required />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input type="tel" name="phone_no" placeholder="Phone No" required />
                      </Col>
                      <Col size={12} className="px-1">
                        <textarea rows="6" name="message" placeholder="Your message..." required></textarea>
                        <button type="submit" disabled={loading}>
                          {loading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <span>Send</span>
                          )}
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
